import React from "react";

class ReviewsSentiment extends React.Component {
  render() {
    const {
      totalReviews = 0,
      thisWeekReviews = 0,
      lastWeekReviews = 0,
      thisWeekOrders = 0,
      lastWeekOrders = 0,
      positiveRate = 0,
      avgRating = 0
    } = this.props;

    const rating5 = avgRating > 0 ? (avgRating / 20).toFixed(1) : (positiveRate > 0 ? (positiveRate * 5 / 100).toFixed(1) : '-');
    const orderGrowth = lastWeekOrders > 0 ? Math.round(((thisWeekOrders - lastWeekOrders) / lastWeekOrders) * 100) : 0;
    const reviewGrowth = lastWeekReviews > 0 ? Math.round(((thisWeekReviews - lastWeekReviews) / lastWeekReviews) * 100) : 0;
    const reviewRate = thisWeekOrders > 0 ? Math.min(Math.round((thisWeekReviews / thisWeekOrders) * 100), 100) : 0;

    // 상태 판정
    const ratingLabel = rating5 >= 4.5 ? '매우 좋음' : rating5 >= 4.0 ? '좋음' : rating5 >= 3.0 ? '보통' : '개선 필요';
    const positiveLabel = positiveRate >= 90 ? '우수' : positiveRate >= 70 ? '양호' : '개선 필요';

    // 바 퍼센트
    const reviewRatePercent = Math.min(reviewRate, 100);
    const positivePercent = Math.min(positiveRate, 100);

    // 인사이트
    let insight = '';
    if (reviewGrowth > 0 && orderGrowth > 0) {
      insight = '리뷰와 주문이 함께 늘고 있어요! 리뷰 솔루션 효과가 나타나고 있습니다.';
    } else if (reviewGrowth > 0) {
      insight = '리뷰가 ' + Math.abs(reviewGrowth) + '% 늘었어요. 긍정 리뷰가 쌓이면 주문 전환에 도움이 됩니다.';
    } else if (orderGrowth > 0) {
      insight = '주문이 ' + Math.abs(orderGrowth) + '% 늘었어요! 리뷰를 더 확보하면 성장이 가속됩니다.';
    } else if (totalReviews > 0) {
      insight = '리뷰 관리를 꾸준히 하면 고객 신뢰도가 높아져 주문 증가로 이어집니다.';
    } else {
      insight = '첫 리뷰를 등록하고 리뷰 솔루션 효과를 확인해보세요!';
    }

    const GrowthTag = ({ value, suffix }) => {
      const up = value >= 0;
      return (
        <span style={{
          display: 'inline-flex', alignItems: 'center', gap: '2px',
          fontSize: '12px', fontWeight: '700',
          color: up ? '#38a169' : '#e53e3e',
          background: up ? '#f0fff4' : '#fff5f5',
          borderRadius: '4px', padding: '2px 6px'
        }}>
          {up ? '▲' : '▼'} {Math.abs(value)}{suffix || '%'}
        </span>
      );
    };

    const ProgressBar = ({ percent, color, label, rightLabel }) => (
      <div style={{ marginTop: '6px' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '4px' }}>
          <span style={{ fontSize: '11px', color: '#718096' }}>{label}</span>
          <span style={{ fontSize: '11px', fontWeight: '700', color }}>{rightLabel}</span>
        </div>
        <div style={{ background: '#edf2f7', borderRadius: '99px', height: '8px', overflow: 'hidden' }}>
          <div style={{
            width: percent + '%', height: '100%',
            background: `linear-gradient(90deg, ${color}, ${color}aa)`,
            borderRadius: '99px', transition: 'width 0.6s ease'
          }} />
        </div>
      </div>
    );

    return (
      <div style={{
        background: '#fff', borderRadius: '12px', padding: '22px',
        boxShadow: '0 2px 12px rgba(0,0,0,0.08)',
        height: '100%', display: 'flex', flexDirection: 'column', gap: '18px'
      }}>
        {/* 헤더 */}
        <div>
          <h5 style={{ margin: '0 0 2px', fontSize: '17px', fontWeight: '700', color: '#1a202c' }}>리뷰 성과 분석</h5>
          <p style={{ margin: 0, fontSize: '12px', color: '#a0aec0' }}>리뷰가 주문에 미치는 효과</p>
        </div>

        {/* 스토어 건강 상태 */}
        <div style={{
          background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
          borderRadius: '12px', padding: '16px', color: '#fff',
          display: 'flex', justifyContent: 'space-around', textAlign: 'center'
        }}>
          <div>
            <div style={{ fontSize: '28px', fontWeight: '800', lineHeight: 1 }}>{rating5}</div>
            <div style={{ fontSize: '11px', opacity: 0.8, marginTop: '4px' }}>평균 평점</div>
            <div style={{
              display: 'inline-block', marginTop: '4px', fontSize: '10px', fontWeight: '700',
              background: 'rgba(255,255,255,0.25)', borderRadius: '4px', padding: '2px 8px'
            }}>{ratingLabel}</div>
          </div>
          <div style={{ width: '1px', background: 'rgba(255,255,255,0.2)' }} />
          <div>
            <div style={{ fontSize: '28px', fontWeight: '800', lineHeight: 1 }}>{positiveRate}%</div>
            <div style={{ fontSize: '11px', opacity: 0.8, marginTop: '4px' }}>긍정 리뷰 비율</div>
            <div style={{
              display: 'inline-block', marginTop: '4px', fontSize: '10px', fontWeight: '700',
              background: 'rgba(255,255,255,0.25)', borderRadius: '4px', padding: '2px 8px'
            }}>{positiveLabel}</div>
          </div>
        </div>

        {/* 이번주 성과 */}
        <div>
          <div style={{ fontSize: '13px', fontWeight: '700', color: '#2d3748', marginBottom: '10px' }}>이번주 성과</div>
          <div style={{ display: 'flex', gap: '10px' }}>
            {/* 주문 카드 */}
            <div style={{
              flex: 1, background: '#f7fafc', borderRadius: '10px', padding: '14px',
              border: '1px solid #e2e8f0'
            }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '6px', marginBottom: '6px' }}>
                <span role="img" aria-label="주문" style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', width: '24px', height: '24px', borderRadius: '6px', background: '#f0fff4', fontSize: '13px' }}>📦</span>
                <span style={{ fontSize: '12px', color: '#718096', fontWeight: '600' }}>주문</span>
              </div>
              <div style={{ display: 'flex', alignItems: 'baseline', gap: '4px' }}>
                <span style={{ fontSize: '26px', fontWeight: '800', color: '#1a202c' }}>{thisWeekOrders.toLocaleString()}</span>
                <span style={{ fontSize: '12px', color: '#a0aec0' }}>건</span>
              </div>
              <div style={{ display: 'flex', alignItems: 'center', gap: '4px', marginTop: '6px' }}>
                <GrowthTag value={orderGrowth} />
                <span style={{ fontSize: '10px', color: '#a0aec0' }}>지난주 대비</span>
              </div>
            </div>
            {/* 리뷰 카드 */}
            <div style={{
              flex: 1, background: '#f7fafc', borderRadius: '10px', padding: '14px',
              border: '1px solid #e2e8f0'
            }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '6px', marginBottom: '6px' }}>
                <span role="img" aria-label="리뷰" style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', width: '24px', height: '24px', borderRadius: '6px', background: '#f5f3ff', fontSize: '13px' }}>📝</span>
                <span style={{ fontSize: '12px', color: '#718096', fontWeight: '600' }}>리뷰</span>
              </div>
              <div style={{ display: 'flex', alignItems: 'baseline', gap: '4px' }}>
                <span style={{ fontSize: '26px', fontWeight: '800', color: '#1a202c' }}>{thisWeekReviews.toLocaleString()}</span>
                <span style={{ fontSize: '12px', color: '#a0aec0' }}>건</span>
              </div>
              <div style={{ display: 'flex', alignItems: 'center', gap: '4px', marginTop: '6px' }}>
                <GrowthTag value={reviewGrowth} />
                <span style={{ fontSize: '10px', color: '#a0aec0' }}>지난주 대비</span>
              </div>
            </div>
          </div>
        </div>

        {/* 리뷰 효과 지표 */}
        <div>
          <div style={{ fontSize: '13px', fontWeight: '700', color: '#2d3748', marginBottom: '4px' }}>리뷰 효과</div>
          <ProgressBar
            percent={reviewRatePercent}
            color="#667eea"
            label="주문 대비 리뷰 작성률"
            rightLabel={reviewRate + '%'}
          />
          <ProgressBar
            percent={positivePercent}
            color="#38a169"
            label="긍정 리뷰 비율"
            rightLabel={positiveRate + '%'}
          />
          <div style={{ marginTop: '8px', fontSize: '11px', color: '#718096', lineHeight: '17px' }}>
            주문 <b style={{ color: '#2d3748' }}>{thisWeekOrders.toLocaleString()}건</b> 중 <b style={{ color: '#667eea' }}>{thisWeekReviews.toLocaleString()}건</b>의 리뷰가 작성되었고, 그 중 <b style={{ color: '#38a169' }}>{positiveRate}%</b>가 긍정적입니다.
          </div>
        </div>

        {/* 인사이트 */}
        <div style={{
          background: '#fffbeb', borderRadius: '8px', padding: '12px 14px',
          display: 'flex', alignItems: 'center', gap: '10px', marginTop: 'auto',
          border: '1px solid #fef3c7'
        }}>
          <span role="img" aria-label="인사이트" style={{ fontSize: '20px' }}>💡</span>
          <span style={{ fontSize: '12px', color: '#92400e', lineHeight: '17px', fontWeight: '500' }}>{insight}</span>
        </div>
      </div>
    );
  }
}

export default ReviewsSentiment;
